// src/Pages/DotsEcoBlogs.js

import './DotsEcoBlogs.css';
import Header from '../Assets/Components/Header.js';
import Footer from '../Assets/Components/Footer.js';

// Importing blog images
import BlogCover01 from '../Assets/Images/blogCovers/01.jpg';
import BlogCover02 from '../Assets/Images/blogCovers/02.jpg';
import BlogCover03 from '../Assets/Images/blogCovers/03.jpg';
import BlogCover04 from '../Assets/Images/blogCovers/04.jpg';
import BlogCover05 from '../Assets/Images/blogCovers/05.jpg';
import BlogCover06 from '../Assets/Images/blogCovers/06.jpg';
import BlogCover07 from '../Assets/Images/blogCovers/07.jpg';
import BlogCover08 from '../Assets/Images/blogCovers/08.jpg';
import BlogCover09 from '../Assets/Images/blogCovers/09.jpg';
import BlogCover10 from '../Assets/Images/blogCovers/10.jpg';
import BlogCover11 from '../Assets/Images/blogCovers/11.jpg';
import BlogCover12 from '../Assets/Images/blogCovers/12.jpg';
import BlogCover13 from '../Assets/Images/blogCovers/13.jpg';
import BlogCover14 from '../Assets/Images/blogCovers/14.jpg';
import BlogCover15 from '../Assets/Images/blogCovers/15.jpg';
import BlogCover16 from '../Assets/Images/blogCovers/16.jpg';


// Blog list with link and representative photos
const blogs = [
  {
    text: 'What happens when wildlife habitats are protected through Dots.eco?',
    image: BlogCover01,
    url: 'https://dots.eco/what-happens-when-wildlife-habitats-are-protected/',
  },
  {
    text: 'Meet the Leatherback Turtle, a Gentle and Essential Giant',
    image: BlogCover02,
    url: 'https://dots.eco/meet-the-leatherback-turtle/',
  },
  {
    text: 'Illegal, unreported, and unregulated fishing: an introduction',
    image: BlogCover03,
    url: 'https://dots.eco/illegal-unreported-and-unregulated-fishing-an-introduction/',
  },
  {
    text: 'Trust, but verify: How we choose our environmental partners',
    image: BlogCover04,
    url: 'https://dots.eco/trust-but-verify-how-we-choose-our-environmental-partners/',
  },
  {
    text: 'What happens to the plastic we collect?',
    image: BlogCover05,
    url: 'https://dots.eco/what-happens-to-the-plastic-we-collect/',
  },
  {
    text: 'Bats, myths, and Ecosystems: The spooky season’s eco-heroes',
    image: BlogCover06,
    url: 'https://dots.eco/bats-myths-and-ecosystems-the-spooky-seasons-eco-heroes/',
  },
  {
    text: 'All you need to know about COP29',
    image: BlogCover07,
    url: 'https://dots.eco/all-you-need-to-know-about-cop29/',
  },
  {
    text: 'What has been achieved after COP29?',
    image: BlogCover08,
    url: 'https://dots.eco/what-has-been-achieved-after-cop29/',
  },
  {
    text: 'Wildfires in the Peruvian Amazon: An introduction',
    image: BlogCover09,
    url: 'https://dots.eco/wildfires-in-the-peruvian-amazon-an-introduction/',
  },
  {
    text: 'Restoring Kelp Forests: Our New Impact',
    image: BlogCover10,
    url: 'https://dots.eco/restoring-kelp-forests-our-new-impact/',
  },
  {
    text: 'CSRD: Getting your company started',
    image: BlogCover11,
    url: 'https://dots.eco/csrd-getting-your-company-started/',
  },
  {
    text: 'Project Update: Restoring the Atlantic Forest in Argentina',
    image: BlogCover12,
    url: 'https://dots.eco/project-update-restoring-the-atlantic-forest-in-argentina/',
  },
  {
    text: 'Our approach to carbon credits and carbon offseting',
    image: BlogCover13,
    url: 'https://dots.eco/carbon-offset-with-dots-eco/',
  },
  {
    text: 'The truth behind the buzz: it’s time to talk about native bees',
    image: BlogCover14,
    url: 'https://dots.eco/native-bees-conservation/',
  },
  {
    text: 'Our newest impact category: Providing clean water where needed',
    image: BlogCover15,
    url: 'https://dots.eco/water-ecosystems-and-climate-providing-clean-water-where-needed/',
  },
  {
    text: 'The deep current warning we can’t afford to ignore',
    image: BlogCover16,
    url: 'https://dots.eco/southern-ocean-currents-climate-impact/',
  },
  
];


// Rendering blog page
const DotsEcoBlogs = () => {
  return (
    <div className='blog-page'>
        <Header />

        <div className='blog-main-content'>
            <div className='blog-page-title'><h1>Blogs written for <a className='blog-page-dots-link' href='https://dots.eco' target='_blank' rel='noopener noreferrer'>Dots.eco</a></h1>
            <div className='blog-page-legend'>All images sourced from <a className='blog-page-legend-link' href='https://commons.wikimedia.org/wiki/Main_Page'> Wikimedia Commons</a>.</div>
            </div>
            <div className='blog-grid'>
                {blogs.map((blog, index) => (
                    <div className='blog-box' title={blog.text} key={index}>
                        <a className='blog-link' href={blog.url} target='_blank' rel='noopener noreferrer'>
                            <div className='blog-box-top' style={{ '--bg-url': `url(${blog.image})` }}>
                            </div>
                            <div className='blog-box-bottom'>
                                <p>{blog.text}</p>
                            </div>
                        </a>
                    </div>
                ))}
            </div>
        </div>
      
        <Footer />
    </div>
  );
};

export default DotsEcoBlogs;